import React from 'react';
import PropTypes from 'prop-types';

import NotificationAction from "./NotificationAction";
import NotificationTitle from "./NotificationTitle";

NotificationContentHeader.propTypes = {
    notification: PropTypes.object,
    isHovered: PropTypes.bool
};

function NotificationContentHeader({notification, isHovered = false}) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            <NotificationTitle notification={notification} />
            <NotificationAction isHovered={isHovered} notification={notification} />
        </div>
    );
}

export default NotificationContentHeader;
